export enum DELETE_ACTION_TYPE {
  DELETE_ALL = "DELETE_ALL",
  DELETE_SELECTED = "DELETE_SELECTED",
}

export enum POST_ACTION_TYPE {
  POST_ALL = "POST_ALL",
  POST_SELECTED = "POST_SELECTED",
}
